import React, { useEffect, useState } from "react";
import "./Grid.css";
import RealTimeMonitoring from "../../Monitoring/RealTimeMonitoring";
import LoadingSpiner from "../../Common/LoadingSpiner";
import { getBreathalyzerModalAveragesApi } from "../../../api/api";

const formatNumber = (value) => {
  if (value === undefined || value === null) {
    return "N/A";
  }

  if (Number.isInteger(value)) {
    return value;
  } else {
    return value.toFixed(2);
  }
};

const ReadingsChart = (props) => {
  const [loading, setLoading] = useState(true);
  const [averages, setAverages] = useState({
    avgBAC: 0,
    avgAuditC: 0,
    avgDrinksPerDay: 0,
  });

  useEffect(() => {
    fetchData();
  }, [props.user, props.currentMonth]);

  const fetchData = async () => {
    setLoading(true);
    const res = await getBreathalyzerModalAveragesApi(
      props.user,
      props.currentMonth
    );
    if (res?.error) {
      Toast.fire({
        icon: "error",
        title: "Something went wrong",
      });
    } else {
      setAverages({
        avgBAC: res.avgBAC || 0,
        avgAuditC: res.avgAuditC || 0,
        avgDrinksPerDay: res.avgDrinksPerDay || 0,
      });
    }
    setLoading(false);
  };

  return (
    <div className="w-full">
      {loading ? (
        <div className="h-[500px] flex justify-center items-center">
          <LoadingSpiner loading={loading} />
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <div className="flex flex-row justify-center">
            <div className="flex flex-col m-5">
              <p>avg. BAC (%)</p>
              <p className="font-bold text-3xl">
                {formatNumber(averages.avgBAC)}
              </p>
            </div>

            <div className="flex flex-col m-5">
              <p>avg. AuditC</p>
              <p className="font-bold text-3xl">
                {formatNumber(averages.avgAuditC)}
              </p>
            </div>

            <div className="flex flex-col m-5">
              <p>avg. drinks/day</p>
              <p className="font-bold text-3xl">
                {formatNumber(averages.avgDrinksPerDay)}
              </p>
            </div>
          </div>

          <RealTimeMonitoring
            user={props.user}
            patientInfo={props.patientInfo}
            breathalyzer={props.breathalyzer}
          />
        </div>
      )}
    </div>
  );
};

export default ReadingsChart;
